import { render, staticRenderFns } from "./reportDeta.vue?vue&type=template&id=6450e194&scoped=true"
import script from "./reportDeta.vue?vue&type=script&lang=js"
export * from "./reportDeta.vue?vue&type=script&lang=js"
import style0 from "./reportDeta.vue?vue&type=style&index=0&id=6450e194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6450e194",
  null
  
)

export default component.exports